import { render, staticRenderFns } from "./ScatterChart.vue?vue&type=template&id=f63239e4&scoped=true"
import script from "./ScatterChart.vue?vue&type=script&lang=js"
export * from "./ScatterChart.vue?vue&type=script&lang=js"
import style0 from "./ScatterChart.vue?vue&type=style&index=0&id=f63239e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63239e4",
  null
  
)

export default component.exports